//  Sectors start
import Dentists from "../Assests/Img/dentist.webp";
import Veterinarians from "../Assests/Img/Veterinarians.webp";
import RealEstate from "../Assests/Img/RealEstate.webp";
import Healthcare from "../Assests/Img/Healthcare.webp";
import Construction from "../Assests/Img/Construction.webp";
import Contractors from "../Assests/Img/contractor.webp";
import Retail from "../Assests/Img/Retail.webp";
import eCommerce from "../Assests/Img/eCommerce.webp";
import Technology from "../Assests/Img/Technology.webp";
import Startups from "../Assests/Img/Startups.webp";
// / Sectors end
import RogerChawla from "../Assests/Img/RogerChawla.webp";
import Anil from "../Assests/Img/Anil.webp";
import Robert from "../Assests/Img/Robert.webp";
import Rajan from "../Assests/Img/Rajan.webp";
import Emma from "../Assests/Img/Emma.webp";
import Greg from "../Assests/Img/Greg.webp";
import Hanna from "../Assests/Img/Hanna.webp";
import Rebecca from "../Assests/Img/Rebecca.webp";
import Melody from "../Assests/Img/Melody.webp";
import Pankaj from "../Assests/Img/Pankaj.webp";
import Nicholas from "../Assests/Img/Nicholas.webp";
import Donald from "../Assests/Img/Donald.webp";
import Passion from "../Assests/Img/Passion.webp";
import Relationship from "../Assests/Img/Relationship.webp";
import Quality from "../Assests/Img/Quality.webp";
import PayingItForward from "../Assests/Img/paying it forward.webp";
import TaxesPreparation from "../Assests/Img/TaxesPreparation.webp";
import AccountingServices from "../Assests/Img/AccountingServices.webp";
import AdvisoryConsulting from "../Assests/Img/AdvisoryConsulting.webp";
import homeless from "../Assests/Img/homeless.webp";
import collective from "../Assests/Img/collective.webp";
import Enviroment from "../Assests/Img/Enviroment.webp";
import Passionimg from "../Assests/Img/Passion-img.webp";
import TrustedRelationship from "../Assests/Img/TrustedRelationship.webp";
import qualityimg from "../Assests/Img/qualityimg.webp";
import PayingItForwardIcon from "../Assests/Img/Paying It Forward icon.png";
import payrollservices from "../Assests/Img/payrollservices.webp";
import auditassurance from "../Assests/Img/auditassurance.webp";
import financialstatements from "../Assests/Img/financialstatements.webp";
import bookkeeping from "../Assests/Img/bookkeeping.webp";
import crypto from "../Assests/Img/crypto.webp";
import businessadvisory from "../Assests/Img/Business-Advisory.webp";
import cfo from "../Assests/Img/cfo.webp";
import controllership from "../Assests/Img/Controllership.webp";
import successionplanning from "../Assests/Img/Succession-Planning.webp";
import TaxFinancialPlanning from "../Assests/Img/Tax-Financial-Planning.webp";
import MAStrategy from "../Assests/Img/M&A-Strategy.webp";
import ProfessionalServicesLogo from "../Assests/Img/Professional-Services-logo.webp";
import ConsultingServiceslogo from "../Assests/Img/Consulting-Services-logo.webp";
import SmallMediumBusinesses from "../Assests/Img/Small-Medium-Businesses.webp";
import ServiceBasedBusinesses from "../Assests/Img/Service-Based-Businesses.webp";
import TransportationLogisticsImg from "../Assests/Img/Transportation-Logistics.webp";
import cryptoIcon from "../Assests/Img/crypto-icon.webp";
import ManufacturingDistribution from "../Assests/Img/Manufacturing-Distribution.webp";
import NonProfitOrganizations from "../Assests/Img/Non-Profit-Organizations.webp";
// sectorsData
export const sectorsData = [
  {
    id: 1,
    imgSrc: [RealEstate],
    title: "Real Estate",
    description:
      "We offer tax planning, bookkeeping, and financial reporting services to real estate investors, agents, and developers, irrespective of the property tax strategies or 1031 exchanges. ",
  },
  {
    id: 2,
    imgSrc: [Healthcare],
    title: "Healthcare",
    description: (
      <>
        Our adept <b>tax accountants in Naperville</b> helps medical experts,
        clinics, and healthcare startups navigate tax planning, payroll
        management, and financial compliance with ease.
      </>
    ),
  },
  {
    id: 3,
    imgSrc: [Construction],
    title: "Construction ",
    description: (
      <>
        Our <b>CPA firm in Naperville, IL</b> specializes in tax strategies, job
        costing, and cash flow management, helping construction companies
        maximize profits and stay IRS-compliant.
      </>
    ),
  },
  {
    id: 4,
    imgSrc: [Contractors],
    title: "Contractors",
    description:
      "We provide reliable tax and accounting solutions for contractors, helping manage expenses, deductions, and IRS compliance for maximized savings in the long run.",
  },
  {
    id: 5,
    imgSrc: [Retail],
    title: "Manufacturing",
    description: (
      <>
        We help manufacturing businesses with cost accounting, inventory
        management, and tax planning to improve profitability and stay
        IRS-compliant.
      </>
    ),
  },
  {
    id: 6,
    imgSrc: [eCommerce],
    title: "eCommerce",
    description: (
      <>
        Our <b>accounting firm in Naperville</b> helps traditional as well as
        modern eCommerce businesses with inventory accounting, tax planning,
        cash flow management, and IRS tax solutions.
      </>
    ),
  },
  {
    id: 7,
    imgSrc: [Technology],
    title: "Technology",
    description: (
      <>
        From SaaS companies to small tech companies, our{" "}
        <b>CPA firm in Naperville, IL</b> offers financial forecasting, R&D tax
        credits, and CFO advisory to help you scale efficiently.
      </>
    ),
  },
  {
    id: 8,
    imgSrc: [Startups],
    title: "Startups",
    description: (
      <>
        As a <b>top-rated CPA in Naperville</b>, we provide startups with
        tax-efficient structures, custom financial planning, and investor-ready
        financials for long-term success.
      </>
    ),
  },
];

// teamData
export const teamData = [
  {
    id: 1,
    imgSrc: [RogerChawla],
    name: "Roger Chawla",
    position: "CPA & Founder",
    description:
      "He is the driving force behind the success of Chawla & Associates, with decades of expertise in accounting. ",
  },
  {
    id: 2,
    imgSrc: [Melody],
    name: "Melody",
    position: "Accountant and Tax Preparer",
    description:
      "She is a superstar in preparing financial statements and providing budgeting and tax planning assistance.",
  },
  {
    id: 3,
    imgSrc: [Greg],
    name: "Greg",
    position: "CPA",
    description:
      "Holds experience in auditing and accounting with expertise in negotiation strategies.",
  },
  {
    id: 4,
    imgSrc: [Rebecca],
    name: "Rebecca",
    position: "Office Manager",
    description:
      "Manages daily office operations and client coordination, ensuring a smooth, efficient, and professional experience for every client interaction.",
  },
  {
    id: 5,
    imgSrc: [Hanna],
    name: "Hannah",
    position: "Administration and Tax ",
    description:
      "She manages administration and contributes to the firm's automation initiatives.",
  },
  {
    id: 6,
    imgSrc: [Robert],
    name: "Robert (Bob)",
    position: "Financial Accountant",
    description:
      "Brings experience in financial accounting and business management, providing consultative support to clients during complex operational transitions.",
  },
  {
    id: 7,
    imgSrc: [Pankaj],
    name: "Pankaj",
    position: "Accounting and Finance Professional",
    className: "Pankaj",
    description:
      "He is skilled in advising clients on accounting, tax preparation, and profit analysis. He lets you navigate the complex finance landscape with confidence. ",
  },
  {
    id: 8,
    imgSrc: [Rajan],
    name: "Rajan",
    position: "Administrator",
    className: "Rajan",
    description:
      "Supports administrative operations and internal coordination, helping maintain efficient processes and smooth day-to-day office functions.",
  },
  {
    id: 9,
    imgSrc: [Donald],
    name: "Donald",
    position: "Finance",
    className: "Donald",
    description:
      "Supports financial operations and reporting, contributing to sound financial management and informed business decisions.",
  },
  {
    id: 10,
    imgSrc: [Nicholas],
    name: "Nicholas",
    position: "Operations Manager",
    className: "Pankaj",
    description:
      "Experienced in leading operations, optimizing processes, and enhancing client service, helping the firm run efficiently and delivering a seamless experience.",
  },
  {
    id: 11,
    imgSrc: [Emma],
    name: "Emma",
    position: "Chartered Accountant (ACA)",
    description:
      "She is an experienced and meticulous accountant and auditing expert. ",
  },
  {
    id: 12,
    imgSrc: [Anil],
    name: "Anil",
    position: "Technology Leader",
    description:
      "Anil has great experience as a technology leader in staff development and complex program management. ",
  },
];
export const teamMembers = [
  {
    name: "Roger Chawla",
    role: "CPA & Founder",
    img: RogerChawla,
    desc: "Roger is the driving force behind Chawla & Associates. He cares deeply about the success of his clients and is closely involved in helping them achieve their goals across every aspect of the firm. As a lifelong Illinois resident, he works extensively with individuals and businesses in the local community, focusing on tax preparation and business advisory. Roger is committed to making high-quality CFO and financial consulting services more accessible and practical for growing businesses. Outside of work, he is a devoted husband, father, and active member of his community who enjoys spending time in nature.",
  },
  {
    name: "Melody",
    role: "Accountant and Tax Preparer",
    img: Melody,
    desc: "Melody holds over six years of experience in accounting and financial management. With an MBA in Accounting, she specializes in tax preparation, financial reporting, budgeting, and forecasting. Dedicated to helping her clients in tax and financial matters, she is passionate about delivering personalized solutions. Outside of work, she enjoys family time, outdoor adventures, and community involvement.",
  },
  {
    name: "Greg",
    role: "CPA",
    img: Greg,
    desc: "Greg carries with him audit and accounting experience from PriceWaterhouseCoopers and international financial reporting. His additional expertise in cost-reduction techniques and supplier negotiation makes him an asset. He holds a bachelor's degree in accounting from the University of Cincinnati. Outside of work, he enjoys traveling with his family to warmer destinations, Aruba being their favorite getaway.",
  },
  {
    name: "Rebecca",
    role: "Office Manager",
    img: Rebecca,
    desc: "Rebecca brings years of experience in office administration and client service, along with a strong commitment to excellence and organization. With a background in operations coordination, team support, and process management, she ensures the office runs smoothly while delivering a polished, client-focused experience. Rebecca is known to pair her professional expertise with a dedication to continuous growth and community involvement, always striving to elevate both the team and the clients she serves.",
  },
  {
    name: "Hannah",
    role: "Administration and Tax",
    img: Hanna,
    desc: "At Chawla & Associates, Hannah is mostly involved in administration, tax preparation, and automation projects. She is a graduate from the University of Illinois at Chicago and is currently on the road to earning her Enrolled Agent (EA) status. Additionally, Hannah is involved in her family's local honey business. Apart from this, for her love of adventure, she enjoys traveling, volunteering, and hiking in her spare time.",
  },
  {
    name: "Robert (Bob)",
    role: "Financial Accountant",
    img: Robert,
    desc: "Bob brings strong experience in financial accounting and business management to Chawla & Associates. With a practical approach to financial analysis and operational strategy, he supports clients in navigating complex business transitions and financial decision-making. Bob works closely with the team to ensure accurate reporting and sound financial processes that help businesses operate efficiently and plan for sustainable growth.",
  },
  {
    name: "Pankaj",
    role: "Accounting and Finance Professional",
    img: Pankaj,
    desc: "Pankaj Vagadia, a seasoned accounting and finance professional with over 40 years of experience, has worked across accounting firms, financial institutions, and the hospitality industry. His expertise spans payroll management, financial reporting, bank reconciliations, and profitability analysis, ensuring businesses maintain financial accuracy and efficiency. Apart from work, he enjoys yoga and long walks, embracing a balanced lifestyle.",
  },
  {
    name: "Rajan",
    role: "Administrator",
    img: Rajan,
    desc: "Rajan supports the day-to-day administrative functions at Chawla & Associates, helping ensure smooth internal operations across the firm. With a focus on organization, coordination, and efficiency, he assists the team in maintaining streamlined processes and effective communication. His role contributes to creating a well-structured environment that supports both the firm and its clients.",
  },
  {
    name: "Donald",
    role: "Finance",
    img: Donald,
    desc: "Donald plays an important role in supporting the financial operations at Chawla & Associates. With a focus on financial reporting, analysis, and operational efficiency, he contributes to maintaining strong financial systems within the firm. His work helps ensure that clients receive reliable insights and financial clarity, enabling informed decisions and better business outcomes.",
  },
  {
    name: "Nicholas",
    role: "Operations Manager",
    img: Nicholas,
    desc: "Nicholas Gerger brings extensive experience in operations management and business administration, along with a strong commitment to efficiency and team success. With a background in process optimization, client service coordination, and organizational leadership, he ensures smooth day-to-day operations while maintaining a client-focused approach. Nicholas combines his professional expertise with a dedication to continuous improvement and community engagement, always working to drive meaningful results.",
  },
  {
    name: "Emma",
    role: "Chartered Accountant (ACA)",
    img: Emma,
    desc: "Emma, a Chartered Accountant (ACA) from Ireland, brings a wealth of expertise in accounting, finance, and audit to Chawla & Associates. With experience in both investment finance and audit practices in Dublin, she offers a well-rounded perspective on financial strategy and compliance. Since joining in 2024, Emma has been dedicated to helping businesses get through complex financial spaces with precision.",
  },
  {
    name: "Anil",
    role: "Technology Leader",
    img: Anil,
    desc: "Anil has great experience as a technology leader in staff development and complex program management. He has worked in various industries like telecom, software, and public safety. He used to lead analytics, IT, operations, and R&D teams. Anil's forte is in building performance-oriented teams and maintaining good relations with clients. Having such expertise, he is a great consultant with the best bits of advice possible for his clients.",
  },
];
// home page data
export const professionalsData = [
  {
    imgSrc: [TaxesPreparation], // Replace with actual path or import
    title: "Tax Services",
    description: (
      <>
        Our expert tax accountants in Naperville, IL, make tax filing simple and
        stress-free. Whether you need help with income tax preparation, business
        filings, or estate and trust tax planning, we ensure accuracy in every
        return. If you receive an IRS notice or experience a tax delay, we offer
        responsive IRS representation and tax notice assistance - resolving
        issues quickly and efficiently.
      </>
    ),
    link: "/services/taxes",
  },
  {
    imgSrc: [AccountingServices], // Replace with actual path or import
    title: "Accounting Services",
    description: (
      <>
        We help businesses maintain financial clarity with expert bookkeeping,
        payroll, and financial statement preparation. As a trusted{" "}
        <b>accounting firm in Naperville</b>, we also offer audit & assurance
        services to ensure compliance. We provide specialized tax solutions for
        cryptocurrency investors too.
      </>
    ),
    link: "/services/accounting-services",
  },
  {
    imgSrc: [AdvisoryConsulting], // Replace with actual path or import
    title: "Advisory & Consulting",
    description:
      "Our business advisory and CFO services in Naperville help optimize cash flow, strengthen financial controls, and drive growth. We assist with succession planning, growth strategies, and tax planning. We develop business plans and help make clients lender-ready to support business growth, ensuring your business is future-ready with smart decision-making.",
    link: "/services/advisory-consulting",
  },
];

export const iconBoxesData = [
  {
    imgSrc: [homeless], // Replace with actual path or import
    alt: "homeless",
    title: "Assisting the homeless",
    description:
      "Fundraising projects can be for a variety of purposes such as community improvement, helping the homeless.",
  },
  {
    imgSrc: [collective], // Replace with actual path or import
    alt: "collective",
    title: "Working for collective change",
    description:
      "Fundraising projects can be for a variety of purposes such as community improvement, helping the homeless.",
  },
  {
    imgSrc: [Enviroment], // Replace with actual path or import
    alt: "Environment",
    title: "Working for Environment change",
    description:
      "Fundraising projects can be for a variety of purposes such as community improvement, helping the homeless.",
  },
];

export const coreValuesData = [
  {
    imgSrc: [Passion], // Replace with actual path or import
    alt: "Passion",
    title: "Passion",
    description: (
      <>
        A vested interest and an inner desire to help you achieve your business
        goals.
      </>
    ),

    boxClass: "first-box", // Unique class for each box
  },
  {
    imgSrc: [Relationship], // Replace with actual path or import
    alt: "Trusted Relationship",
    title: "Trusted Relationship",
    description: (
      <>
        A commitment to build and keep your trust through a long term
        relationship of mutual respect.
      </>
    ),
    boxClass: "second-box",
  },
  {
    imgSrc: [Quality], // Replace with actual path or import
    alt: "Quality",
    title: "Quality",
    description: (
      <>
        A commitment to accomplish your work with the highest standards of
        applicable guidelines and ethical values.
      </>
    ),
    boxClass: "third-box",
  },
  {
    imgSrc: [PayingItForwardIcon], // Replace with actual path or import
    alt: "Paying It Forward",
    title: "Paying It Forward",
    description: (
      <>
        A belief that success carries a responsibility to give back and create
        opportunities for others.
      </>
    ),
    boxClass: "fourth-box",
  },
];

// About page data
export const aboutInfoData = [
  {
    title: "Personalization",
    description: (
      <>
        Every financial situation is distinct. As your CPA in Naperville, we do
        not believe in one-size-fits-all solutions. We make the effort to
        understand your business and provide tailored advice and strategies that
        pertain to your needs and goals.
      </>
    ),
  },
  {
    title: "Proactive Approach",
    description: (
      <>
        We anticipate problems and opportunities before they arise, and we have
        a strategic approach to help you address them and reach your goals.
        Whether you’re looking for a tax accountant in Naperville or need
        comprehensive CPA services for your small business, we’ve got you
        covered.
      </>
    ),
  },
  {
    title: "Transparency",
    description: (
      <>
        We believe in clear and open communication. We explain complex financial
        matters in a way you can understand, ensuring you are always kept up to
        date and able to make informed decisions. Our CPA in Naperville, IL
        services are transparent and straightforward.
      </>
    ),
  },
  {
    title: "Dedicated Support",
    description: (
      <>
        We are not merely tax accountants in Naperville - we are your trusted
        financial advisors. We are with you every step of the way, helping you
        navigate financial changes and challenges. We take great pride in
        building long-term relationships with our clients.
      </>
    ),
  },
];

export const aboutcoreValuesData = [
  {
    imgSrc: [Passionimg], // Replace with the actual import or path
    alt: "Passion",
    title: "Passion",
    description:
      "A vested interest and an inner desire to help you achieve your business goals. ",
    className: "passion",
  },
  {
    imgSrc: [TrustedRelationship], // Replace with the actual import or path
    alt: "Trusted Relationship",
    title: "Trusted Relationship",
    description:
      "A commitment to build and keep your trust through a long term relationship of mutual respect.",
    className: "top-spacing trusted-relationship",
  },
  {
    imgSrc: [qualityimg], // Replace with the actual import or path
    alt: "Quality",
    title: "Quality",
    description:
      "A commitment to accomplish your work with the highest standards of applicable guidelines and ethical values.",
    className: "top-spacing quality",
  },
  {
    imgSrc: [PayingItForward], // Replace with the actual import or path
    alt: "Paying It Forward",
    title: "Paying It Forward",
    description:
      "A belief that success carries a responsibility to give back and create opportunities for others.",
    className: "top-spacing quality",
  },
];

// Services page data
export const accountingSolutionsData = [
  {
    imgSrc: [bookkeeping],
    alt: "Bookkeeping Services",
    title: "Bookkeeping Services",
    description: (
      <>
        Keep your finances organized, accurate, and up to date with our
        professional bookkeeping services. Our{" "}
        <b>accounting firm in Naperville</b> manages transactions, accounts, and
        reconciliations. Whether you’re a small business or a growing
        enterprise, we help you maintain error-free records and IRS compliance
        while saving time and reducing stress.
      </>
    ),

    buttonLink: "/services/accounting-services/bookkeeping-services",
  },
  {
    imgSrc: [financialstatements],
    alt: "Financial Statements",
    title: "Financial Statements",
    description: (
      <>
        Gain clear, reliable financial reports tailored to your business needs.
        Our <b>accounting services in Naperville</b> prepare profit & loss
        statements, balance sheets, and cash flow reports, empowering you to
        make informed business decisions. We ensure accuracy, compliance with
        accounting standards, and readiness for audits or investor reviews.
      </>
    ),
    buttonLink: "/services/accounting-services/financial-statements",
  },
  {
    imgSrc: [payrollservices], // Replace with the actual import or path
    alt: "Payroll",
    title: "Payroll",
    description: (
      <>
        We offer hassle-free, accurate payroll solutions that ensure on-time
        employee payments, correct tax withholdings, and full compliance with
        state and federal payroll laws. Whether you have a small team or a large
        workforce, our <b>accounting services in Naperville</b> help you avoid
        penalties, streamline processes, and focus on growth.
      </>
    ),
    buttonLink: "/services/accounting-services/payroll", // Add your desired link here
  },
  {
    imgSrc: [auditassurance],
    alt: "Audit & Assurance",
    title: "Audit & Assurance",
    description: (
      <>
        Our <b>accounting firm in Naperville</b> specializes in comprehensive
        audit and assurance services designed to enhance financial transparency,
        mitigate risks, and build stakeholder trust. We provide internal audits,
        financial statement audits, and compliance audits, ensuring your
        business meets regulatory requirements and maintains credibility.
      </>
    ),
    buttonLink: "/services/accounting-services/audit-assurance",
  },

  {
    imgSrc: [crypto],
    alt: "Crypto",
    title: "Crypto",
    description:
      "Crypto taxation is complex, but we simplify it with expert tax and accounting solutions. Our team ensures compliance with evolving IRS regulations, proper capital gains reporting, and strategic planning to minimize tax liabilities. Whether you're an investor, trader, or business dealing with digital assets, we help you stay IRS-compliant and financially secure.",
    buttonLink: "/services/accounting-services/crypto",
  },
];

export const consultingServicesData = [
  {
    imgSrc: [businessadvisory],
    alt: "Business Advisory",
    title: "Business Advisory",
    description:
      "Gain a strategic edge with expert guidance designed to help your company scale, improve operational efficiency, and navigate financial challenges. Our team delivers customized insights, business plan development, and lender-readiness support to enhance profitability, strengthen cash flow, and sustainable growth.",
    buttonLink: "/services/advisory-consulting/business-advisory",
  },
  {
    imgSrc: [cfo],
    alt: "CFO Services",
    title: "CFO Services",
    description:
      "Access outsourced CFO solutions to drive financial leadership, strategic planning, and long-term business success. We assist with financial forecasting, risk management, budget planning, and investment strategies, helping your company stay financially sound and competitive without the overhead of a full-time CFO.",
    buttonLink: "/services/advisory-consulting/CFO",
  },
  {
    imgSrc: [controllership],
    alt: "Controllership",
    title: "Controllership ",
    description:
      "We provide expert financial management to ensure accurate reporting, cost control, and compliance while strengthening internal controls and financial decision-making. Our controllership services help businesses streamline processes, improve cash flow management, and maintain financial transparency and accountability.",
    buttonLink: "/services/advisory-consulting/controllership-services",
  },
  {
    imgSrc: [successionplanning],
    alt: "Succession Planning",
    title: "Succession Planning",
    description:
      "Secure your company’s future with a well-structured succession plan for smooth leadership and ownership transitions. Whether preparing for a generational shift, an executive handover, or a business sale, we develop customized exit strategies that ensure stability, business continuity, and financial security for all stakeholders.",
    buttonLink: "/services/advisory-consulting/succession-planning",
  },
  {
    imgSrc: [TaxFinancialPlanning],
    alt: "Tax & Financial Planning",
    title: "Tax & Financial Planning",
    description: (
      <>
        We offer tailored tax and financial planning strategies to help you
        minimize tax liabilities, maximize savings, and secure long-term
        financial stability. Our{" "}
        <b>tax advisory and consulting in Naperville</b> provides investment
        planning, retirement strategies, estate planning, and proactive tax
        optimization, ensuring that your financial goals are achieved with
        precision.
      </>
    ),
    buttonLink: "/services/advisory-consulting/tax-financial-planning",
  },
  {
    imgSrc: [MAStrategy],
    alt: "Growth Strategy",
    title: "Growth Strategy",
    description: (
      <>
        Drive sustainable growth with strategic tax advisory and business
        consulting tailored to your goals. From expansion planning and financial
        forecasting to capital structuring and performance optimization, we help
        businesses scale confidently, minimize risk, and build a strong
        financial foundation for long-term success.
      </>
    ),
    buttonLink: "/services/advisory-consulting/growth-strategy",
  },
];

// Industries page data

export const IndustriessectorsData = [
  {
    imgSrc: [SmallMediumBusinesses],
    title: "Small & Medium Businesses (SMBs)",
    description: (
      <>
        SMBs require robust financial management to navigate tax regulations and
        sustain growth. Our <b>CPA services for your industry in Naperville</b>{" "}
        include business tax preparation, payroll processing, bookkeeping, and
        IRS compliance. We help small businesses optimize cash flow, reduce tax
        burdens, and maintain accurate financial records. Whether you run a
        family business or a growing enterprise, our expert accountants ensure
        financial clarity and long-term success.
      </>
    ),
  },
  {
    imgSrc: [RealEstate],
    title: "Real Estate",
    description:
      "It takes skill to handle real estate financing, and our CPA services in Naperville provide it. We help builders, agents, and real estate investors with bookkeeping, financial reporting, and tax-efficient strategies. We provide compliance while optimizing deductions for property depreciation, rental income taxes, and 1031 exchange management. Our customized accounting solutions assist you in staying ahead of the competition, streamlining cash flow, and making informed choices.",
  },
  {
    imgSrc: [Healthcare],
    title: "Healthcare",
    description: (
      <>
        Our <b>CPA firm in Naperville IL</b> helps you understand the
        complicated financial laws that the healthcare industry must comply
        with. For physicians, clinics, and new healthcare businesses, we offer
        expert tax planning, payroll management, and financial compliance
        services. We oversee your accounts, from handling medical deductions to
        making sure financial procedures adhere to HIPAA. While you concentrate
        on patient care, our CPAs assist you in navigating the ever-changing
        healthcare tax needs, minimizing liabilities, and boosting
        profitability.
      </>
    ),
  },
  {
    imgSrc: [Construction],
    title: "Construction",
    description: (
      <>
        For construction businesses to remain successful, precise job costing
        and cash flow management are essential. For contractors and construction
        companies, our <b>CPA firm in Naperville, IL</b>, specializes in
        financial planning, customized tax solutions, and IRS compliance. We
        help you in tracking your expenses, managing project budgets, and
        maximizing deductions. Our team ensures your finances are set up for
        optimal effectiveness and profitability, whether you're dealing with
        subcontractor payments or equipment depreciation.
      </>
    ),
  },
  {
    imgSrc: [Dentists],
    title: "Dentists",
    description: (
      <>
        Dental practices face unique financial complexities from managing
        insurance reimbursements and payroll to handling equipment depreciation
        and tax compliance. At Chawla & Associates, we provide specialized
        accounting and tax services tailored for dentists and dental clinics.
        Our CPAs help you optimize cash flow, plan for tax efficiency, manage
        practice growth, and stay compliant with changing regulations, so you
        can focus on delivering exceptional patient care while we handle your
        financial health.
      </>
    ),
  },
  {
    imgSrc: [Veterinarians],
    title: "Veterinarians",
    description: (
      <>
        Veterinary practices face unique financial and operational challenges
        from managing payroll and inventory costs to navigating complex tax
        regulations and equipment investments. At Chawla & Associates, our
        experienced CPAs provide tailored accounting, tax planning, and advisory
        services specifically designed for veterinarians in Naperville, IL. We
        help solo practitioners and multi-location clinics streamline
        bookkeeping, optimize cash flow, maximize deductions, and plan for
        long-term growth.
      </>
    ),
  },
  {
    imgSrc: [Contractors],
    title: "Contractors",
    description:
      "Small construction companies and independent contractors require financial plans that maximize savings and simplify tax procedures. To help contractors reduce their liabilities, our CPAs offer bookkeeping, tax planning, and cost management services. We find deductions unique to your trade while ensuring adherence to IRS requirements. We assist you in maximizing profits and preserving financial stability all year long with our personalized accounting services.",
  },
  {
    imgSrc: [Retail],
    title: "Retail",
    description:
      "From inventory management to sales tax compliance, retail enterprises address particular financial issues. Expert accounting solutions from our CPA firm make financial tracking easier and boost profitability. We help with expense control, profit margin analysis, and bookkeeping to maintain your retail business financially stable. Regardless of your business model - boutique, franchise, or multi-location - we assist you in navigating tax complexity and optimizing your profits.",
  },
  {
    imgSrc: [cryptoIcon],
    title: "Crypto",
    description:
      "Cryptocurrency taxation is complex, but our Naperville CPA firm simplifies it for investors and businesses. We provide expert tax reporting, capital gains tracking, and compliance solutions for crypto traders, miners, and blockchain companies. Whether you're dealing with DeFi investments or NFT transactions, we ensure accurate tax filings and IRS compliance. Stay ahead of crypto tax regulations with our specialized CPA services.",
  },
  {
    imgSrc: [Technology],
    title: "Technology",
    description: (
      <>
        Our <b>CPA firm in Naperville, IL</b> provides the future-focused
        financial strategies that tech companies seek. We provide financial
        forecasts, R&D tax credits, and CFO advisory services to software
        developers, SaaS companies, and IT startups. We support new businesses
        in scaling effectively, from managing investor finance to streamlining
        tax arrangements. Our advisory services guarantee financial clarity so
        that you can concentrate on innovation and expansion.
      </>
    ),
  },
  {
    imgSrc: [Startups],
    title: "Startups",
    description:
      "For startups that seek funding and drive growth, comprehensive financial planning is essential. Our Naperville CPA firm assists start-up companies with fundraising plans, investor-ready financials, and tax-efficient entity structures. We offer startup-specific bookkeeping, tax compliance, and cash flow management services. Our financial know-how ensures long-term success whether you're scaling with venture capital or with bootstrapping.",
  },
  {
    imgSrc: [ManufacturingDistribution],
    title: "Manufacturing & Distribution",
    description: (
      <>
        Manufacturing and distribution companies rely heavily on effective
        financial management. We offer payroll administration, IRS tax
        solutions, and inventory cost analysis as part of our{" "}
        <b>CPA services for your industry in Naperville</b>. We assist
        manufacturers with tax burden reduction, depreciation management, and
        supply chain budget management. Whether you have variable material costs
        or complex regulatory requirements, our CPAs assure financial stability
        and optimum profitability.
      </>
    ),
  },
  {
    imgSrc: [NonProfitOrganizations],
    title: "Non-Profit Organizations",
    description: (
      <>
        For non-profits to preserve their tax-exempt status and ensure
        regulatory compliance, careful financial management is necessary.
        Accurate financial reporting, <b>IRS help near Naperville</b>, and
        tax-efficient planning are all included in our Naperville CPA services.
        We assist religious organizations, foundations, and charities with grant
        funding, donation tracking, and annual tax returns. You can concentrate
        on your purpose while we take care of the financial details under our
        expert guidance.
      </>
    ),
  },
  {
    imgSrc: [ProfessionalServicesLogo],
    title: "Professional Services",
    description: (
      <>
        Lawyers, architects, engineers, and other service professionals rely on
        our <b>CPA firm in Naperville</b> for expert financial counseling. To
        help you maximize deductions and reduce obligations, we offer tax
        planning, bookkeeping, and compliance services. We simplify your
        financial operations, whether you're handling client retainers or
        company spending. Our customized plans assure financial security so you
        can concentrate on providing outstanding services.
      </>
    ),
  },
  {
    imgSrc: [ConsultingServiceslogo],
    title: "Consulting Services",
    description:
      "For consultants to control income, costs, and tax liabilities, they require well-defined financial plans. For consultants in a variety of industries, our CPAs offer proactive financial planning, IRS representation, and skilled tax optimization. Whether you are a growing business or a solo consultant, we assist you in tracking expenses, optimizing deductions, and ensuring tax law compliance.",
  },

  {
    imgSrc: [ServiceBasedBusinesses],
    title: "Service-Based Businesses",
    description:
      "Service providers, ranging from repair shops and salons to coaching firms, require effective financial methods. Our Naperville CPA firm provides personalized bookkeeping, cash flow management, and tax preparation services. We assist service companies in maintaining IRS compliance, optimizing deductions, and streamlining spending. With our experience, you can concentrate on providing excellent services, and we'll take care of the finances.",
  },
  {
    imgSrc: [TransportationLogisticsImg],
    title: "Transportation & Logistics",
    description: (
      <>
        Managing a transportation or logistics business comes with complex
        financial challenges. Our <b>CPA firm in Naperville</b> specializes in
        fleet depreciation, fuel tax credits, and financial forecasting. We
        assist trucking companies, delivery services, and logistics firms in
        optimizing tax strategies and maintaining compliance with IRS
        regulations. Our tailored accounting solutions help improve operational
        efficiency and profitability.
      </>
    ),
  },
  {
    imgSrc: [eCommerce],
    title: "eCommerce",
    description: (
      <>
        Our <b>CPA services for your industry in Naperville</b> offer the agile
        financial strategies needed in the digital industry. We provide online
        companies with expert accounting services, such as tax planning,
        inventory management, and multi-state sales tax compliance. We assist
        you with managing tax responsibilities and optimizing cash flow,
        regardless of whether businesses operate on Shopify, Amazon, or other
        platforms. Our customized consultation services make sure your eCommerce
        company grows economically while adhering to tax regulations.
      </>
    ),
  },
];

export const jobListings = [
  {
    title: "Senior Tax Accountant",
    description:
      "The Senior Tax Accountant will prepare and review multiple tax projects in order to provide quality tax services and deliverables for our clients.",
    link: "/contact/careers/senior-tax-accountant",
  },
  // {
  //   title: "Audit Associate",
  //   description:
  //     "At Chawla and Associates CPAs, our Audit Associates play a key role in delivering high-quality audit services while maintaining the highest standards of integrity, objectivity, and professional skepticism. ",
  //   link: "/contact/careers/audit-associate",
  // },
  {
    title: "Bookkeeping Specialist",
    description:
      "Chawla and Associates CPAs is a premier accounting firm dedicated to providing high-quality financial services to businesses and individuals.",
    link: "/contact/careers/bookkeeping-specialist",
  },
  {
    title: "Administrative Assistant",
    description:
      "Chawla and Associates CPAs is seeking an Administrative Assistant to join our team. As a full-service CPA firm, we specialize in tax, accounting, and consulting services for individuals and businesses.",
    link: "/contact/careers/administrative-assistant",
  },
];

export const tabData = [
  { id: "Education", title: "Education" },
  { id: "Homelessness", title: "Homelessness" },
  { id: "MentalHealth", title: "Mental Health" },
  { id: "Gardeninginitiative", title: "Gardening initiative" },
];

export const tabContent = {
  Gardeninginitiative: {
    description:
      "As part of our commitment to environmental responsibility, we actively promote sustainable gardening practices within our workplace and community. Our gardening initiative encourages green spaces, supports biodiversity, and contributes to a healthier environment. Through small but meaningful actions, we aim to create long-term positive impact beyond our professional services.",
  },
  Education: {
    description:
      "Education is the greatest equalizer. It unlocks opportunities and empowers individuals to shape their own future. Our CPA firm is committed to overcoming the pandemic learning loss in our communities. We support various programs and initiatives across Illinois. We foster partnerships between schools and community stakeholders to increase access to both academic and non-academic programs. Our efforts help enrich opportunities for students and their families. Our vision is to promote a more educated community while building a stronger and more connected neighborhood.",
  },
  Homelessness: {
    description:
      "It’s heartbreaking that so many people are forced to live on the streets. This is not because they are any different from us, but because life hasn’t been too kind to them. At Chawla & Associates CPAs, our vision is to take meaningful steps toward ending homelessness. We proudly support numerous organizations dedicated to providing shelter, food, legal assistance, and a range of vital services to those in need. While we recognize that this is a complex issue that can’t be solved overnight, we are honored to be part of the collective effort working towards a future where homelessness will be a thing of the past.",
  },
  DrugsAndRehabilitation: {
    description:
      "Substance use disorder is neither a death sentence nor a personal choice. It is a medical condition that requires compassion and specialized care, as those affected often feel helpless. At Chawla & Associates CPAs, we deeply understand this, which is why we contribute a significant amount of resources to combat substance abuse. We recognize the challenges that individuals struggling with addiction face, and we are proud to extend a helping hand. After all, isn’t the essence of humanity to support one another in times of need?",
  },
  MentalHealth: {
    description:
      "It’s easy to take mental health for granted; until you encounter someone who is struggling with it. In our work, we have seen firsthand the challenges faced by persons dealing with mental health issues. That is why, at Chawla & Associates CPAs, we are proud to partner with organizations that are dedicated to providing essential mental health support. While we may not be equipped to offer the specialized services those affected need, we can offer funding to organizations that can provide the necessary care and resources. Supporting these organizations brings us great joy, as it allows us to make a meaningful and positive impact on people's lives.",
  },
};
